import texturometro1 from '../texturometro/texturometro1.png'

const texturometroImages = [
    texturometro1,
]

export default texturometroImages